import { render, staticRenderFns } from "./HsabExpenseManagement.vue?vue&type=template&id=24ba075c&scoped=true"
import script from "./HsabExpenseManagement.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba075c",
  null
  
)

export default component.exports